import { Response } from '../../../../generic/v2/response/response';
import { CommunicationsRequestName } from '../../../communications-request-name';

export abstract class CommunicationsResponse<T> extends Response<CommunicationsRequestName, T> {}
